import $ from 'jquery';
import debounce from 'lodash/debounce';
import attachPhoneContext, { setPhoneValidity } from './phoneContext';

const DEBOUNCE_INTERVAL = 50;
const OPT_FORM_SELECTOR = '.opt-form, .viz-form';
const OPT_FORM_HAS_ERRORS = 'opt-form--show-errors viz-form--show-validation';
const DATE_INPUT_SELECTOR = '[data-mask-date]';
const PHONE_VALIDATE_SELECTOR = '[data-validate-phone]';
const PHONE_VALIDATED_ATTR = 'phone-is-valid';
const PHONE_VALIDATED_VAL = 'validated';
const PHONE_VALIDATE_URL = '/api/v1/phone_numbers';

export function parseDate (date) {
  return date
    .replace(/[^\d]/g, '')
    .split('')
    .reduce((str, char, i) => `${str}${[2, 4].includes(i) ? '/' : ''}${char}`, '');
}

// Native <input type="date"> exchanges ISO (YYYY-MM-DD) with the DOM, but the checkout
// wire format is MM/DD/YYYY (CheckoutApiService splits on '/'). Convert at the component
// boundary so the submitted value stays unchanged.
export function isoToUsDate (isoDate) {
  if (!isoDate) {
    return '';
  }

  const [year, month, day] = isoDate.split('-');
  if (!year || !month || !day) {
    return '';
  }

  return `${month}/${day}/${year}`;
}

export function usDateToIso (usDate) {
  if (!usDate) {
    return '';
  }

  const [month, day, year] = usDate.split('/');
  if (!month || !day || !year) {
    return '';
  }

  return `${year}-${month}-${day}`;
}

export function validatePhoneNumber (num) {
  return $.ajax({
    url: `${PHONE_VALIDATE_URL}/${encodeURIComponent(num)}`,
    method: 'GET',
  });
}

function maskDateInput () {
  this.value = parseDate(this.value);
}

function browserSupportsInputTypeDate () {
  const input = document.createElement('input');
  input.setAttribute('type', 'date');

  const notADateValue = 'not-a-date';
  input.setAttribute('value', notADateValue);

  return input.value !== notADateValue;
}

function padDateParameter (str) {
  return str.length < 2 ? `0${str}` : str;
}

function convertISOtoMMDDYYYY (iso) {
  const date = new Date(iso);
  return [date.getMonth() + 1, date.getDate(), date.getFullYear()]
    .map((num) => padDateParameter(num.toString()))
    .join('/');
}

function attachDateContext () {
  const $date = $(DATE_INPUT_SELECTOR);
  if ($date.attr('type') === 'text' || !browserSupportsInputTypeDate()) {
    $(document).on('keyup change', DATE_INPUT_SELECTOR, debounce(maskDateInput, DEBOUNCE_INTERVAL));
    const utc = $date.data('utc');
    if (utc) {
      const date = convertISOtoMMDDYYYY(utc);
      $(DATE_INPUT_SELECTOR).val(date).trigger('keyup');
    }
  }
}

export function formIsValid ($form) {
  return $form.find('select, textarea, input').toArray().every((el) => el.checkValidity());
}

export function shouldValidatePhone ($form) {
  const $phone = $form.find(PHONE_VALIDATE_SELECTOR);
  return $phone.length &&
    $phone.val() &&
    $phone.data(PHONE_VALIDATED_ATTR) !== PHONE_VALIDATED_VAL;
}

export function markFormAsInvalid ($form, animate = true) {
  $form.addClass(OPT_FORM_HAS_ERRORS);
  if (animate) $('html, body').animate({ scrollTop: $form.find(':invalid').offset().top });
}

export function validatePhone ($form) {
  return new Promise((resolve, reject) => {
    const $phone = $(PHONE_VALIDATE_SELECTOR);
    const num = $phone.intlTelInput('getNumber');
    validatePhoneNumber(num)
      .then((response) => {
        if (response.is_valid) {
          $phone.data(PHONE_VALIDATED_ATTR, PHONE_VALIDATED_VAL);
          $phone.val(num);
          $form.data('validated', true);
        } else {
          setPhoneValidity($phone, false);
          markFormAsInvalid($form);
        }
        resolve(response.is_valid);
      })
      .fail(() => {
        reject();
      });
  });
}

function interceptAndValidateOptFormSubmission (e) {
  const $form = $(this);

  if (!formIsValid($form)) {
    e.preventDefault();
    markFormAsInvalid($form);
  } else if (shouldValidatePhone($form)) {
    e.preventDefault();
    validatePhone($form)
      .then((isValid) => {
        if (isValid) $form.submit();
      });
  }
}

function attachOptFormContext () {
  $(document).on('submit', OPT_FORM_SELECTOR, interceptAndValidateOptFormSubmission);
  attachPhoneContext();
  attachDateContext();
}

export default attachOptFormContext;
